import { useNavigate, useParams } from "react-router-dom";
import { Header } from "../../../../../components/Header";
import { BackArrow } from "../../../../../Icons/BackArrow";
import { useGetData } from "../../../../../Network/useGetQueryData";
import TableList from "../../../../../ui-component/Table";
import { ColumnsType } from "antd/es/table";
import "./style.scss";
import { SelectedMark } from "../../../../../Icons/ActiveMark";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

export const PriceListTable = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const { providerId, serviceId } = useParams();

  const { data, isLoading } = useGetData<{ data: any }>({
    queryKey: ["service-provider-service"],
    url: `service-provider-services?serviceId=${serviceId}&serviceProviderId=${providerId}`,
    options: {
      enabled: !!providerId,
      queryKey: ["service-provider-service"],
    },
  });

  const { data: provider } = useGetData<{ data: any }>({
    queryKey: ["service-provider-details"],
    url: `service-provider/${providerId}`,
    options: {
      enabled: !!providerId,
      queryKey: ["service-provider-details"],
    },
  });

  const providerColumns: ColumnsType<any> = [
    {
      title: t("providers.table.serviceName"),
      dataIndex: "name",
      key: "name",
      width: 150,
      render: (_, record) => (
        <div className="title-with-img">
          <p>{record.service?.name?.[i18n.language || "en"]}</p>
        </div>
      ),
    },
    {
      title: t("providers.table.id"),
      dataIndex: "code",
      key: "code",
    },
    {
      title: t("providers.table.price"),
      dataIndex: "Price",
      key: "Price",
      render: (_, record) => <p>{record?.price}LE</p>,
    },
    {
      title: t("providers.table.pPercentage"),
      dataIndex: "cr",
      key: "P-Percentage",
      render: (_, record) => (
        <p>{((record?.medHubPrice / record?.price) * 100).toFixed(2)}%</p>
      ),
    },
    {
      title: t("providers.table.patientValue"),
      dataIndex: "pv",
      key: "P-v",
      render: (_, record) => <p>{record?.medHubPrice}</p>,
    },
    {
      title: t("providers.table.status"),
      dataIndex: "status",
      key: "status",
      render: (_, record) => (
        <p style={{ textTransform: "capitalize" }}>{record.status}</p>
      ),
    },
    {
      title: t("providers.table.serviceStart"),
      dataIndex: "ServiceStart",
      key: "ServiceStart",
      render: (_, record) => (
        <p>{dayjs(record.createdAt).format("DD/MM/YYYY")}</p>
      ),
    },
    {
      title: t("providers.table.serviceEnd"),
      dataIndex: "end",
      key: "end",
      render: () => <p>-</p>,
    },
  ];

  return (
    <>
      <Header
        title={t("header.providers")}
        backIcon={
          <span
            style={{ cursor: "pointer" }}
            onClick={() => navigate("/providers")}
          >
            <BackArrow />
          </span>
        }
      />
      <div className="provider-list-table-header">
        <h2>
          {provider?.data?.name?.[i18n.language || "en"]} {t("table.priceList")}
        </h2>
      </div>

      <div className="list-table-prices">
        <div className="table-prices-header">
          <p>
            <SelectedMark />
            {provider?.data?.name?.[i18n.language || "en"]}{" "}
            {t("table.priceList")}
          </p>
        </div>
        <TableList
          data={data?.data?.items}
          columns={providerColumns}
          loading={isLoading}
          rowKey="id"
          loadMore={() => {}}
          isLoadMore={isLoading}
          height="calc(-330px + 100vh)"
        />
      </div>
    </>
  );
};
